export default __webpack_public_path__ + "static/media/background.7eae97b6.png";